// src/api/ligaApi.js
const API_URL = process.env.REACT_APP_API_URL || "http://192.168.0.16:3001/api";
const SERVER_BASE_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace("/api", "")
  : "http://192.168.0.16:3001";

const getAuthHeaders = (isFormData = false) => {
  const token = localStorage.getItem("adminToken");
  const headers = {};
  if (!isFormData) {
    headers["Content-Type"] = "application/json";
  }
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  return headers;
};

const handleResponse = async (response) => {
  if (response.status === 401 || response.status === 403) {
    localStorage.removeItem("adminToken");
    window.location.reload();
    throw new Error(
      "Sessão inválida ou expirada. Por favor, faça login novamente."
    );
  }
  if (!response.ok) {
    const err = await response.json().catch(() => ({
      message: `Erro de Servidor: Status ${response.status}`,
    }));
    throw new Error(
      err.message || err.error || "Ocorreu um erro desconhecido."
    );
  }
  if (response.status === 204) {
    return { success: true };
  }
  return response.json().catch(() => ({ success: true }));
};

export const getEscudoUrl = (originalUrl) => {
  if (!originalUrl) return "";
  if (originalUrl.startsWith("/uploads")) {
    return `${SERVER_BASE_URL}${originalUrl}`;
  }
  return `${API_URL}/image-proxy?url=${encodeURIComponent(originalUrl)}`;
};

export const loginAdmin = async (email, password) => {
  const response = await fetch(`${API_URL}/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  return handleResponse(response);
};

export const getDadosCompletos = async () => {
  const response = await fetch(`${API_URL}/dados-completos`);
  return handleResponse(response);
};

export const addEquipe = async (nome) => {
  const response = await fetch(`${API_URL}/equipes`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ nome }),
  });
  return handleResponse(response);
};

export const removeEquipe = async (id) => {
  const response = await fetch(`${API_URL}/equipes/${id}`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const updateTitulosEquipe = async (equipeId, quantidade) => {
  const response = await fetch(`${API_URL}/equipes/${equipeId}/titulos`, {
    method: "PUT",
    headers: getAuthHeaders(),
    body: JSON.stringify({ titulos: Number(quantidade) }),
  });
  return handleResponse(response);
};

export const addTime = async (timeData) => {
  const response = await fetch(`${API_URL}/times`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(timeData),
  });
  return handleResponse(response);
};

export const removeTime = async (id) => {
  const response = await fetch(`${API_URL}/times/${id}`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const searchCartolaTimes = async (query) => {
  if (!query) return [];
  const response = await fetch(
    `${API_URL}/cartola/search?q=${encodeURIComponent(query)}`
  );
  return handleResponse(response);
};

export const fetchScoresForRound = async (numero) => {
  const response = await fetch(`${API_URL}/rodadas/${numero}/fetch-scores`, {
    method: "POST",
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const updateAllTimes = async () => {
  const response = await fetch(`${API_URL}/times/update-all`, {
    method: "PUT",
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const resetarPontuacoes = async () => {
  const response = await fetch(`${API_URL}/rodadas/reset`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const resetScoresForRound = async (numero) => {
  const response = await fetch(`${API_URL}/rodadas/${numero}/reset`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const getAdmins = async () => {
  const response = await fetch(`${API_URL}/admins`, {
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const addAdmin = async (adminData) => {
  const response = await fetch(`${API_URL}/admins`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(adminData),
  });
  return handleResponse(response);
};

export const deleteAdmin = async (id) => {
  const response = await fetch(`${API_URL}/admins/${id}`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const setCaptain = async (timeId, equipeId) => {
  const response = await fetch(`${API_URL}/times/${timeId}/set-captain`, {
    method: "PUT",
    headers: getAuthHeaders(),
    body: JSON.stringify({ equipeId }),
  });
  return handleResponse(response);
};

export const uploadLogo = async (equipeId, formData) => {
  const response = await fetch(`${API_URL}/equipes/${equipeId}/logo`, {
    method: "POST",
    headers: getAuthHeaders(true),
    body: formData,
  });
  return handleResponse(response);
};
